/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    /*!*************************************************!*\
      !*** ./scripts/custom/verwijzers/onlineForm.js ***!
      \*************************************************/
    (function (window, document) {
        function addTitleToForm() {
            var div = document.getElementsByClassName("verwijsformulier")[0];
            var title = document.createElement("h1");
            title.textContent = "Verwijsformulier";
            title.classList.add("form-title");
            div === null || div === void 0 ? void 0 : div.prepend(title);
        }


        function addDefaultDateToForm() {
            // Get the input element based on the parent div's class
            var inputElement = document.querySelector('.redenvanverwijzingenvraagstelling2 .datepickerfield');
            var inputElementShadow = document.querySelector('.redenvanverwijzingenvraagstelling2 .datepickerfieldshadow');
        
            // Now you can set the value of the input field
            if (inputElement && inputElementShadow) {
                const date = new Date();
                const formattedDate = date.toISOString().split('T')[0];

                // Set the value of the input field to the formatted date
                inputElement.value = formattedDate;
                inputElementShadow.value = formattedDate;
            } else {
                console.log("Input elements not found.");
            }
        }

        function getCurrentFormattedDate() {
            const date = new Date();
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');

            console.log(`new Date("${year}-${month}-${day}")`);

            return `new Date("${year}-${month}-${day}")`;
        }        
        function createCollapsableSection() {
            var elementIdsAndClasses = ["aded5e77-60ff-4440-9573-71ce3ef05fbc", "anamnese", "datumlaatstebezoek2", "acdaafee-559f-451d-e417-3b467d2a6c8d", "d75052af-ef42-463d-e821-923d41406aab", "c9df0a5f-1992-4084-d59d-1c43ff309321", "595795ac-901b-4019-e224-db92e0f441b8", "a48f94f8-1308-43d9-cab0-b112cf4b4d70", "dd33c870-ba13-41dd-f118-daa914b4e269", "dea08686-67ec-45da-f027-60a67a0c4290", "bccec8cb-13ac-4554-977c-b4983cfab6d4"];
            var positionReference = document.querySelector(".oogheelkundigegegevens");

            var divToAdd = document.createElement("div");
            divToAdd.classList.add("hide-collapse");
            divToAdd.id = "collapse-button";
            positionReference === null || positionReference === void 0 ? void 0 : positionReference.prepend(divToAdd);
            positionReference.classList.remove("umbraco-forms-field");

            for (var _i = 0, _elementIdsAndClasses = elementIdsAndClasses; _i < _elementIdsAndClasses.length; _i++) {
                var idOrClass = _elementIdsAndClasses[_i];
                var element = document.getElementById(idOrClass) || document.getElementsByClassName(idOrClass)[0];

                if (element) {
                    divToAdd.append(element);
                }
            }
        }

        function collapseFunctionalty() {
            var legendElement = document.getElementById('c35e0c42-15d2-4e51-8cd0-dc47131ff70e');
            legendElement === null || legendElement === void 0 ? void 0 : legendElement.classList.add("collapse-header");
            legendElement.children[0].classList.add("minus-icon");
            legendElement === null || legendElement === void 0 ? void 0 : legendElement.firstElementChild.addEventListener("click", function () {
                var collapse = document.getElementById("collapse-button");
                collapse.classList.toggle("collapsable-section");
                collapse.classList.toggle("hide-collapse");
                legendElement.children[0].classList.toggle('plus-icon');
                legendElement.children[0].classList.toggle('minus-icon');
            });
        }



        //var form = document.getElementById("6109ea44-fd3b-4bb9-9edf-605b5f50ede6");
        //form.style.paddingTop = "0px";
        //var specialismeIds = ["c6a6f1d4-4b3c-43bf-a46f-3a6f0d92b26c_0", "c6a6f1d4-4b3c-43bf-a46f-3a6f0d92b26c_1", "c6a6f1d4-4b3c-43bf-a46f-3a6f0d92b26c_2", "c6a6f1d4-4b3c-43bf-a46f-3a6f0d92b26c_3","c6a6f1d4-4b3c-43bf-a46f-3a6f0d92b26c_4"];

        //for (var _i2 = 0, _specialismeIds = specialismeIds; _i2 < _specialismeIds.length; _i2++) {
        //    var radioButtonId = _specialismeIds[_i2];
        //    var button = document.getElementById(radioButtonId);
        //    button.addEventListener('click', function () {
        //        namelijkDiv.style.display = "none";
        //        namelijkDiv.children[1].children[0].value = "";
        //    });
        //}

        //var jaAnswer = document.getElementById("516e9f31-3f0c-4fb2-fedc-fdd4bc4f5983_1");
        //var neAnswer = document.getElementById("516e9f31-3f0c-4fb2-fedc-fdd4bc4f5983_0");
        //var namelijk2 = document.getElementsByClassName("namelijk2")[0];
        //jaAnswer.addEventListener('click', function () {
        //    namelijk2.style.display = "flex";
        //});
        //neAnswer.addEventListener('click', function () {
        //    namelijk2.style.display = "none";
        //    namelijk2.children[1].children[0].value = "";
        //});

        function formValidate() {
            var observer = new MutationObserver(function (mutations) {
                var errorSpans = document.querySelectorAll('.field-validation-error');
                errorSpans.forEach(function (errorSpan) {
                    // Check if .field-validation-error span contains text different than *
                    var textContent = errorSpan.textContent.trim();
                    var hasDifferentText = textContent !== '*' && textContent !== '&#42;'; // Check for both '*' and '&#42;' (HTML entity for *)
                    // Check if .field-validation-error span has a nested span with *

                    var hasNestedSpanWithStar = errorSpan.querySelector('span') !== null && errorSpan.querySelector('span').innerText.trim() === '*'; // Check if the associated input field is empty

                    var inputField = errorSpan.closest('.umbraco-forms-field-wrapper').querySelector('input');
                    var isInputEmpty = !inputField || inputField.value.trim() === ''; // Add or remove 'error-active' class based on conditions

                    if ((hasDifferentText || !hasNestedSpanWithStar) && !isInputEmpty) {
                        errorSpan.parentNode.classList.add('error-active');
                    } else {
                        errorSpan.parentNode.classList.remove('error-active');
                    }
                });
            }); // Start observing

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }

        addTitleToForm();
        addDefaultDateToForm();
        createCollapsableSection();
        collapseFunctionalty();
        formValidate(); 

    })(window, document);
    /******/
})()
    ;
//# sourceMappingURL=customVerwijzersOnlineForm.bundle.js.map